// Deepgram listen WebSocket query string builder.
// Extracted from `deepgramStreamingEngine.ts` so sample_rate can vary per session.

const DEEPGRAM_LISTEN_MODEL = "nova-3";

/**
 * Build the `wss://api.deepgram.com/v1/listen?...` query for raw linear16 PCM.
 * Nova-3 streaming supports 8 kHz and 16 kHz linear16 for en-US per Deepgram docs.
 */
export function buildDeepgramListenQuery(sampleRateHz: number): string {
  return new URLSearchParams({
    model: DEEPGRAM_LISTEN_MODEL,
    encoding: "linear16",
    sample_rate: String(sampleRateHz),
    language: "en-US",
    smart_format: "true",
    punctuate: "true",
    interim_results: "true",
    endpointing: "800",
  }).toString();
}
